
import React from 'react';
import turqoiseLogo from './../../assets/images/iEntry_corporate.png';
import { InputAdornment, Box } from '@mui/material';
import {CustomTextField} from "../../components/CustomTextField";
import {Mail} from "@mui/icons-material";
import {CustomPassword} from "../../components/CustomPassword";
import CustomOtpInput from "../../components/CustomOtpInput";
import {ButtonNextStep} from "../../components/buttons/ButtonNavigation";
import CustomInputLabel from "../../components/CustomInputLabel";
import CustomTitle from "../../components/CustomTitle";
import FullPageLoader from "../../utils/FullPageLoader";
import HomeApp from "./Functionality/HomeApp";

const Home = () => {
    const {
        t, // Translation function
        emptyFields,
        email,
        setEmail,
        password,
        setPassword,
        loading,
        isValidEmail,
        isValidOtp,
        setIsValidOtp,
        otp,
        setOtp,
        showOtp,
        handleEmailChange,
        handleKeyDown,
        handleLogin
    } = HomeApp();

    return (
        <>
            { !sessionStorage?.getItem("bearerToken") &&
                <>
                    <div className={'login-background '}>
                        <div className={"overlay-login d-flex justify-content-center align-items-center"}>
                            <div className={"section-form-login justify-content-center"}>
                                <form onSubmit={(e) => e.preventDefault()} >
                                    <div className={"row"}>
                                        <Box className='col-12 center-text p-0 pb-1 '>
                                            <img src={turqoiseLogo} alt='iEntryCorporate logo' className='ientry-logo' />
                                        </Box>
                                        <div className={"col-12 d-flex justify-content-center mb-4 p-0"}>
                                            <CustomTitle>{t('login')}</CustomTitle>
                                        </div>

                                        <div className={"col-12 p-0"}>
                                            <CustomTextField id={"txt_hm_email"}
                                                             length={128}
                                                             name={"email"}
                                                             value={email}
                                                             trans={"email"}
                                                             type={"text"}
                                                             disabled={false}
                                                             onChange={(e) => {
                                                                 setEmail(e.target.value);
                                                                 handleEmailChange(e);
                                                             }}
                                                             required={true}
                                                             emptyFields={emptyFields}
                                                             isValid={isValidEmail}
                                                             isValidText={"email_format_invalid"}
                                                             InputProps={{
                                                                 endAdornment: (
                                                                     <InputAdornment position='end'>
                                                                         <Mail />
                                                                     </InputAdornment>
                                                                 ),
                                                             }}
                                                             onKeyDown={handleKeyDown}
                                            />
                                        </div>

                                        <div className={"col-12 p-0"}>
                                            <CustomPassword id={"txt_hm_password"}
                                                            name="password"
                                                            length={64}
                                                            value={password}
                                                            onChange={(e) => {
                                                                setPassword(e.target.value);
                                                            }}
                                                            label={"password"}
                                                            required={true}
                                                            emptyFields={emptyFields}
                                                            onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </div>
                                    {showOtp &&
                                    <div className={"row"}>
                                        <div className={"col-12 p-0 mt-0"}>
                                            <CustomOtpInput
                                                value={otp}
                                                onChange={(newValue) => {
                                                    setOtp(newValue);
                                                    setIsValidOtp(true);
                                                }}
                                                required={true}
                                                emptyFields={emptyFields}
                                                isValid={isValidOtp}
                                            />
                                        </div>
                                    </div>
                                    }
                                    <div className={"row"}>
                                        <Box className={"col-12 mt-1 mb-2 p-0"}>
                                            <ButtonNextStep
                                                id="btn_hm_login"
                                                text={"login"}
                                                click={handleLogin}
                                                disabled={false}
                                            />
                                        </Box>

                                    </div>
                                    <div className={"version-number w-100 d-flex justify-content-center pb-2"}>
                                        <CustomInputLabel labelId={"lbl_hm_version_number"} trans={t("PILGRIMS v1.1.2.6")} />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={"rights-reserved"}>{t('rights_reserved') + ' '} <b>{t('app_title')}</b></div>
                    {loading && <FullPageLoader />}
                </>
            }
        </>
    );
};

export default Home;
